import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import SubscriptionService from '../utils/SubscriptionService.js';
import SubscriptionSummary from './SubscriptionSummary.js'
import "../CSS/Dashboard.css"
import CirclePlus from '../images/dbplus@3x.png'
import URLService from '../utils/URLService.js';

export default class Dashboard extends Component {
  constructor(props){
    super(props)
    this.URLService = new URLService()
    var url = this.URLService.getUrl()
    this.state = {
      subscriptions: []
    }
    this.newSubscription = this.newSubscription.bind(this)
  }
  componentDidMount(){


    this.Subscription = new SubscriptionService()

    this.Subscription.getSubscriptions()
    .then(res =>{
      this.setState({
        subscriptions: res.customer_subscriptions
      })
    })
    .catch(err =>{
    })
  }
  newSubscription() {
    window.href = '../'
  }
  //doesn't work yet
  render() {
    var subsriptionsHTML = []
    var this_2 = this
    this.state.subscriptions.forEach(function(sub) {
        subsriptionsHTML.push(<SubscriptionSummary subscription= {sub} /> )
    });
    return (
      <div>
      <h3 className="dashboardHeader">Subscriptions
        <a href="/new-subscription">
          <img className="addIcon" src={CirclePlus} onClick={this.newSubscription}></img>
        </a>
      </h3>
      <br></br>
      <div className="sublist">
        {subsriptionsHTML}
      </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/SubscriptionDashboard.js